export default "__VITE_ASSET__BwWUotbi__"